import { render, staticRenderFns } from "./taskToAddSign.vue?vue&type=template&id=7ffcf0bc&scoped=true&"
import script from "./taskToAddSign.vue?vue&type=script&lang=js&"
export * from "./taskToAddSign.vue?vue&type=script&lang=js&"
import style0 from "./taskToAddSign.vue?vue&type=style&index=0&id=7ffcf0bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffcf0bc",
  null
  
)

export default component.exports